import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentReset from '@material-ui/icons/DeleteSweep';
import IconContentRemB from '@material-ui/icons/RemoveCircle';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Assets imports
import '../styles/NewProject.css';
import { FieldArray } from 'react-final-form-arrays';

// import components
import CustomLoader from './innerComponents/CustomLoader';

import SelectAutocompleteMulti from './innerComponents/SelectAutocompleteMulti'


const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    fieldStyle: {
        minHeight: "72px",
        width: "100%",
    },

    buttonStyle: {
        marginRight: 12,
    },

    paperStyle: {
        // General styles for paper
        width: "60%",
        margin: "0 auto",
        height: "auto",
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'column'
    }
});

const suggestions = [
    {value: "Admin",
    label: "Admin"}
    ,
    {value: "Office Manager",
    label: "Office Manager"
},{
    value: "Supervisor",
    label: "Supervisor"
},{
    value: "Operative",
    label: "Operative"
}
];

class CreateCertificate extends React.Component {

    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
    }

    state = {};

    _createCertification = async values => {
        console.log(JSON.stringify(values, 0, 2))

        const name = values.certificationName;
        // const required = values.required;

        await this.props.mutation_create_certification({
            variables: {
                name
            }
        }).then(({ data }) => {
            console.log('ok')
            console.log(data)
            alert('Certification was created successfully')
            this.props.history.push({
                pathname: "/training/list",
                state: {
                    refetch: true,
                    tab: this.props.location.state.tab,
                }
            });
        }).catch((error) => {
            console.log(error)
            alert(error.message)
        })


    }

    _handleBackClick() {
        this.props.history.replace(
            {
                pathname: "/training/list",
                state: {
                    refetch: false,
                    tab: this.props.location.state.tab,
                }
            });

    }


    render() {

        const required = value => (value ? undefined : 'Required field');

        const TextFieldAdapter = ({ input, meta, ...rest }) => (
            <TextField
                {...input}
                {...rest}
                onChange={(event) => {
                    input.onChange(event.target.value)
                }}
                error={meta.touched && meta.error !== undefined}
                helperText={meta.touched ? meta.error : ''}
            />
        );

        // Check if the query response is being loaded
        if (this.props.all_certifications_query && this.props.all_certifications_query.loading) {
            return <CustomLoader label={'Loading Certifications'}/>
        }

        // Check if there were errrors
        if (this.props.all_certifications_query && this.props.all_certifications_query.error) {
            return <div> Certifications Could not be loaded </div>
        }


        const { classes } = this.props;

        return (
            <Paper className={classes.paperStyle} elevation={1}>
                <div>
                    <Form
                        onSubmit={this._createCertification}
                        mutators={{
                            ...arrayMutators
                        }}
                        render={({ handleSubmit, submitting, pristine, values, form }) => (
                            <form onSubmit={handleSubmit}>

                                <div className="NewProject-header">
                                    <div className="NewProject-title">
                                        <span>New Certification</span>
                                    </div>
                                    <div className="NewProject-actions">
                                        <Button
                                            color="primary"
                                            onClick={() => this._handleBackClick()}
                                        ><IconContentRemB style={{ marginRight: 8 }} /> Cancel</Button>
                                    </div>
                                </div>

                                <div className="NewProject-content">
                                    <div>
                                        <Field
                                            name="certificationName"
                                            validate={required}
                                            label="Certification name:"
                                            component={TextFieldAdapter}
                                            placeholder="Type the certification name"
                                            className={classes.fieldStyle} />
                                    </div>
                                    {/* <div> */}
                                        {/* <Checkbox
                                            color="primary"
                                            onChange={(event) => {
                                                values['required'] = event.target.checked
                                            }}
                                        /> */}
                                        {/* <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(event) => {
                                                        values['required'] = event.target.checked
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label="Is a required certification?"
                                        /> */}
                                        {/* {this.state.requiredCert === true && <FieldArray name="requiredFor">
                                            {({ fields }) =>

                                                <Field
                                                    name="requiredFor"
                                                    options={suggestions}
                                                    component={SelectAutocompleteMulti}
                                                    placeholder="Type to search and add a role"
                                                    validate={required}
                                                    onChange={(event, value) => {
                                                        if (value['action'] === 'select-option') {
                                                            push('requiredFor', value['option']['value'])
                                                        }
                                                        else if (value['action'] === 'remove-value') {
                                                            fields.forEach((name, index) => {
                                                                if (fields['value'][index] === value['removedValue']['value']) {
                                                                    fields.remove(index)
                                                                }
                                                            })
                                                        }

                                                    }
                                                    }
                                                />
                                            }

                                        </FieldArray>} */}
                                    {/* </div> */}

                                </div>

                                <div className="NewProject-detailFooter">
                                    <div className="buttons">

                                        <Button variant="contained"
                                            color="primary"
                                            type="submit"
                                            disabled={submitting || pristine}
                                            className={classes.buttonStyle}
                                        ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>

                                        <Button variant="contained"
                                            type="button"
                                            color="secondary"
                                            onClick={form.reset}
                                            disabled={submitting || pristine}
                                            className={classes.buttonStyle}
                                        ><IconContentReset style={{ marginRight: 8 }} /> Reset</Button>

                                    </div>
                                </div>

                            </form>
                        )}
                    />
                </div>
            </Paper>
        );
    }
}

CreateCertificate.propTypes = {
    classes: PropTypes.object.isRequired,
};

const MUTATION_CREATE_CERTIFICATION = gql`
  mutation createCertification($name: String!){
    createCertification(input:{name: $name}){
      id
    }
  }
`;

export default compose(
    graphql(MUTATION_CREATE_CERTIFICATION, {
        name: 'mutation_create_certification',
        options: {
            refetchQueries: ["all_certifications_query"]
        }
    })
)(withStyles(styles)(CreateCertificate));



// WEBPACK FOOTER //
// src/components/CreateCertification.js